import {
  CardDefaultsResponse,
  FleetLimiter,
} from 'features/cards/components/new-card-modal/types/CardDefaultsResponseTypes';
import { CardModalFormValues } from 'features/cards/components/new-card-modal/types/CardModalFormNames';
import { CardModalMeta, DollarLimits } from 'features/cards/components/new-card-modal/types/CardModalMetaTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';

/** Typed representation of the card detail API response stored in Redux. */
export interface CardDetailRecord {
  cardNumber?: string;
  contractNumber?: string;
  cardStatus?: string;
  fleetLimiters?: FleetLimiter[];
  monthlyDollarLimits?: DollarLimits[];
  dailyDollarLimits?: DollarLimits[];
  vasRsaAccountCode?: string;
  vasSnrAccountCode?: string;
  verifyPosPrompt?: string;
  plasticTypeCode?: string;
  expiryDate?: string;
  [key: string]: unknown;
}

interface CardDetailViewState {
  isLoading: boolean;
  cardDetail: CardDetailRecord | null;
  isError: boolean;
  success: boolean;
  editCardLoading: boolean;
  editCardLoaded: boolean;
  editCardError: boolean;
  isPreviousOrReplacementCardClicked: boolean;
  previousOrReplacementCardNumber: string | null;
  isResetSelectedContent: boolean;
}

export function useSelectCardFormValues() {
  return useSelector((state: RootState) => state.cardsStore.formValues) as CardModalFormValues;
}

export function useSelectAccountDefaults() {
  return useSelector((state: RootState) => state.accountDefaults.result) as CardDefaultsResponse;
}

export function useSelectAccountDefaultsLoading() {
  return useSelector((state: RootState) => state.accountDefaults.isLoading) as boolean;
}

export function useSelectPlasticType() {
  return useSelector((state: RootState) => state.maintenanceStore.plasticType);
}

export function useSelectAssignedGrandfatherClientNumber() {
  return useSelector((state: RootState) => state.userStore.assignedGrandfatherClientNumber) as string;
}

export function useSelectCardOptions() {
  return useSelector((state: RootState) => state.getCardOptions.cardOptions.profiles);
}

export function useSelectCardOptionDetails() {
  return useSelector((state: RootState) => state.getCardOptions.cardOptions);
}

export function useSelectAllAccounts() {
  return useSelector((state: RootState) => state.accountsStore.allAccounts);
}

export function useSelectSelectedCard() {
  return useSelector((state: RootState) => state.cardsStore.selectedCard);
}

export function useSelectCardDetails() {
  return useSelector((state: RootState) => (state.cardDetailView as CardDetailViewState).cardDetail);
}

export function useSelectCardDetailsLoading(): boolean {
  return useSelector((state: RootState) => (state.cardDetailView as CardDetailViewState).isLoading);
}

export function useSelectCardModalMeta() {
  return useSelector((state: RootState) => state.cardsStore.modalMeta) as CardModalMeta;
}

export function useDisableExpiryDate() {
  return useSelector((state: RootState) => state.cardsStore.disableExpiryDate);
}
